

import { jsPDF } from "jspdf";
import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"
import dayjs from "dayjs";
import { numberFormat, numberFormatNoFlotingPoint } from "utils";
import { branchNoText } from "utils/branchNoText";
import { printHeader } from "./pirntHeader";

export const printJobOrderExpense = ({ joData, msData }) => {
  const { CompanyData } = msData.serverData
  const pageWidth = 8.3
  const pageHeight = 11.7
  const pageSize = [pageWidth, pageHeight];
  const contentSize = 16;
  const startY = 0.3
  const startX = 0.5
  const lineHeight = 0.30
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "in",
    format: pageSize
  });

  // let numJobOrder = 0
  let pageNo = 0
  // let maxJobOrderFirst = 19
  // const maxJobOrder = 36
  // let startJobOrder = 0
  // do {
  pageNo++
  if (pageNo !== 1) {
    doc.addPage(pageSize, "portrait")
  }
  let yPos = startY
  let xPos = startX
  // const img = new Image()
  // img.src = companyLogo

  // const logoWidth = 0.85
  // const logoHeight = 0.85
  // try {
  //   doc.addImage(img, 'png', xPos, yPos, logoWidth, logoHeight)
  //   xPos += logoWidth + 0.2
  // } catch (e) {
  //   console.log("error::", e)
  // }
  // doc.setFont("THSarabun", "bold")
  // doc.setFontSize(defaultHeaderSize)
  // yPos += 0.2
  // doc.text(CompanyData.NameEN, xPos, yPos)
  // doc.setFont("THSarabun", "normal")
  // doc.setFontSize(comapanyAddrSize)
  // yPos += lineHeightHeader
  // doc.text(CompanyData.AddrEN, xPos, yPos)
  // yPos += lineHeightHeader
  // doc.text(`Tax ID: ${CompanyData.TaxId}`, xPos, yPos)
  // yPos += lineHeightHeader
  // doc.text(`Tel.: ${CompanyData.Tel}${CompanyData.Fax && ` Fax: ${CompanyData.Fax}`}`, xPos, yPos)

  // yPos += lineHeight

  yPos = printHeader({
    jsPDFDoc: doc, 
    companyData: CompanyData,
    startX: xPos,
    startY: yPos,
  })
  yPos += lineHeight + 0.05
  doc.setFont("THSarabun", "bold")
  doc.setFontSize(contentSize + 2)
  let topRightYPos = startY + 0.2
  doc.text("ค่าใช้จ่ายใบงาน", 6.7, topRightYPos, { align: "center" })
  topRightYPos += lineHeight
  doc.setFontSize(contentSize)
  doc.setFont("THSarabun", "normal")

  doc.text(`ประเภทงาน: ${joData.ShpmTypNm}`, 6.7, topRightYPos, { align: "center" })
  topRightYPos += lineHeight - 0.05
  const aptTm = joData.AptTm ? dayjs(joData.AptTm).startOf('day') : null
  // const maxAptTm = joData.AptTm ? dayjs(joData.MaxAptTm).startOf('day') : null
  // const aptTmTxt = aptTm ? aptTm.isSame(maxAptTm) ? aptTm.format("DD/MM/YYYY") : `${aptTm.format("DD/MM/YYYY")} - ${maxAptTm.format("DD/MM/YYYY")}` : "-"
  doc.text(`วันที่วิ่งงาน:  ${aptTm ? aptTm.format("DD/MM/YYYY") : "-"}`, 6, topRightYPos)

  yPos = yPos - 0.2
  doc.setFont("THSarabun", "bold")
  doc.setFontSize(contentSize + 3)
  doc.text(`เลขที่ใบงาน: ${joData.JobOrdId}`, pageWidth / 2, yPos, { align: "center" })
  const tableFontSize = contentSize -1
  doc.setFontSize(tableFontSize)
  doc.setFont("THSarabun", "normal")
  yPos += lineHeight
  //------------------------------ Convert joData ------------------------------
  let rmk = joData.InvNote || ""
  if (joData.Rmk) {
    rmk += rmk ? `, ${joData.Rmk}` : joData.Rmk
  }
  const dataTableCol1 = [
    { header: "CUSTOMER :", value: joData.CusSNm },
    { header: "JOB NO :", value: joData.JobNo },
    { header: "LOCATION :", value: joData.Loc },
    // { header: "CY :", value: `${joData.TakePlc || "-"} ${joData.TakeArvTm ? ` - Pick up: ${dayjs(joData.TakeArvTm).format("DD/MM/YYYY HH:mm")}` : ""}` },
    { header: "CY :", value: `${joData.TakePlc || "-"}` },
    { header: "COMMODITY :", value: joData.CmdyTyp },
    { header: "Vssel :", value: `${joData.Vssl} V.${joData.Voy}` },
    { header: "ETD :", value: joData.ETD ? dayjs(joData.ETD).format("DD/MM/YYYY") : "-" },
    { header: "Driver :", value: joData.DrvNm },
    // { header: "CONTAINER NO. :", value: `${joData.ContNo}${joData.Ref1 ? `, ตู้กลับ ${joData.Ref1}` : ""}` },
    // { isSecondPage: 1, header: "REMARK :", value: rmk },
  ]
  const dataTableCol2 = [
    { header: "JOB :", value: joData.JobSNm },
    { header: "BOOKING NO :", value: joData.Bkg },
    { header: "PRICE :", value: joData.UntPr ? numberFormatNoFlotingPoint(+joData.UntPr) : "-" },
    // { header: "RETURN :", value: `${joData.RtnPlc || "-"} ${joData.RtnArvTm ? ` - Return: ${dayjs(joData.RtnArvTm).format("DD/MM/YYYY HH:mm")}` : ""}` },
    { header: "RETURN :", value: `${joData.RtnPlc || "-"} ` },
    // { header: "VOLUME :", value: joData.ContSizeFull },
    { header: "Agent :", value: joData.Agnt },
    { header: "Port :", value: joData.Port },
    { header: "ETA :", value: joData.ETA ? dayjs(joData.ETA).format("DD/MM/YYYY") : "-" },
    { header: "Truck :", value: joData.LicNm },
  ]

  const dataTableSingleCol = [
    { header: "CONTAINER NO. :", value: `${joData.ContNo}(${joData.ContSizeFull}) ${joData.Ref1 ? `, ตู้กลับ ${joData.Ref1}` : ""}` },
    { header: "REMARK :", value: rmk },
  ]
  doc.setLineWidth(0.01)
  const startYData = yPos - 0.2
  const col1Width = 3.3
  const col2Width = 3.3
  const headerPos = startX + 0.3
  doc.setFont("THSarabun", "bold")
  yPos = startYData + lineHeight * 2 / 3
  let yPosLine = startYData
  let numLine = 0
  const printTable = (dataTable, startXPos, colWidth, isPrintFirstLine) => {
    numLine = 0
    for (const data of dataTable) {
      if (numLine !== 0 || isPrintFirstLine) {
        doc.line(startXPos, yPosLine, startXPos + colWidth, yPosLine)
      }
      let hWdith = doc.getTextWidth(data.header)
      doc.setFont("THSarabun", "bold")
      doc.text(`${data.header}`, startXPos + 0.1, yPos)
      doc.setFont("THSarabun", "normal")
      doc.text(`${data.value}`, startXPos + 0.1 + hWdith + 0.1, yPos)
      numLine++
      yPos += lineHeight
      yPosLine += lineHeight
    }
  }
  printTable(dataTableCol1, headerPos, col1Width)
  yPos = startYData + lineHeight * 2 / 3
  yPosLine = startYData
  printTable(dataTableCol2, headerPos + col1Width, col2Width)
  doc.line(headerPos + col1Width, startYData, headerPos + col1Width, startYData + (numLine * lineHeight))
  printTable(dataTableSingleCol, headerPos, col1Width + col2Width, true)

  const headerWidth = 0.9
  const detailPos = headerPos + headerWidth + 0.1
  const rcptLineHeight = 0.18

  joData.Rcpt = `${joData.RcptNm}\n${joData.RcptAddr}\nTAX ID: ${joData.RcptTaxId} ${branchNoText(joData.RcptNm, joData.RcptBrchNo)}`
  const rcpts = joData.Rcpt.split("\n")
  doc.line(headerPos, yPosLine, headerPos + col1Width + col2Width, yPosLine)
  
  doc.setFont("THSarabun", "bold")
  doc.text("ที่อยู่ออกใบเสร็จ :", headerPos + 0.1, yPos)
  doc.setFont("THSarabun", "normal")
  doc.setFontSize(tableFontSize-2)
  for (const rcpt of rcpts) {
    const rcptLines = doc.splitTextToSize(rcpt, col1Width + col2Width -headerWidth - 0.3)
    for (const line of rcptLines) {
      doc.text(line, detailPos + 0.2, yPos)
      yPos += rcptLineHeight
      yPosLine += rcptLineHeight
    }
  }
  if (rcpts.length === 0) {
    yPos += lineHeight
    yPosLine += lineHeight
  }
  doc.rect(headerPos, startYData, col1Width + col2Width, yPos -startYData -lineHeight/2 + 0.05, "S")

  const lineHeightDetail = 0.25
  const startExpXpos = headerPos - 0.3
  const noCol = startExpXpos + 0.3
  const contNoSize = 14

  doc.setFontSize(contNoSize)
  doc.setFont("THSarabun", "bold")
  yPos += lineHeightDetail / 2
  doc.text("ค่าใช้จ่ายดำเนินงาน", startExpXpos, yPos)
  doc.setFont("THSarabun", "normal")
  const nameCol = noCol + 0.3
  // const amntCol = nameCol + 2
  // const qtyCol = amntCol + 1.5
  const totalTrnsCol = nameCol + 2.1
  const totalExpCol = totalTrnsCol + 1

  // doc.text("ราคา", amntCol + 0.7, yPos, { align: "right" })
  // doc.text(`จำนวน`, qtyCol - 0.1, yPos)
  doc.text("เงินรับ", totalTrnsCol + 0.8, yPos, { align: "right" })
  doc.text("ค่าใช้จ่าย", totalExpCol + 0.8, yPos, { align: "right" })
  yPos += lineHeightDetail
  let no = 0
  let sumTrns = 0
  for (const trns of joData.PCTrns) {
    no++
    doc.text(`${no}.`, noCol, yPos)
    doc.text(`${trns.ExpNm} ${trns.Dscp ? `(${trns.Dscp})` : ""}`, nameCol, yPos)
    // doc.text(numberFormat(trns.Amnt), amntCol + 1, yPos, { align: "right" })
    // doc.text(`1`, qtyCol, yPos)
    doc.text(numberFormat(trns.Amnt * (trns.InOutTyp === "I" ? -1 : 1)), totalTrnsCol + 1, yPos, { align: "right" })
    yPos += lineHeightDetail - 0.04
    sumTrns += +(trns.Amnt || 0) * (trns.InOutTyp === "I" ? -1 : 1)
  }
  let sumExp = 0
  const foundTripExp = joData.PCItems.find(itm => itm.ExpId === 83)//ค่าเที่ยวคนขับ
  let pcItems = [...joData.PCItems]
  if (foundTripExp) {
    no++
    doc.text(`${no}.`, noCol, yPos)
    doc.text(`(${foundTripExp.IsCost ? "ต้นทุน" : "รายได้"})  ${foundTripExp.ExpNm}`, nameCol, yPos)
    // doc.text(numberFormat(foundTripExp.Amnt), amntCol + 1, yPos, { align: "right" })
    // doc.text(`${foundTripExp.Qty}`, qtyCol, yPos)
    doc.text(numberFormat(foundTripExp.Total), totalExpCol + 1, yPos, { align: "right" })
    yPos += lineHeightDetail - 0.04
    sumExp += +(foundTripExp.Total || 0)
    pcItems = pcItems.filter(itm => itm.ExpId !== 83)
  }

  const hasExpId = []
  for (const exp of pcItems) {
    hasExpId.push(exp.ExpId)
    no++
    doc.text(`${no}.`, noCol, yPos)
    doc.text(`(${exp.IsCost ? "ต้นทุน" : "รายได้"})  ${exp.ExpNm}`, nameCol, yPos)
    // doc.text(numberFormat(exp.Amnt), amntCol + 1, yPos, { align: "right" })
    // doc.text(`${exp.Qty}`, qtyCol, yPos)
    doc.text(numberFormat(exp.Total), totalExpCol + 1, yPos, { align: "right" })
    yPos += lineHeightDetail - 0.04
    sumExp += +(exp.Total || 0)
  }
  doc.setFont("THSarabun", "bold")
  doc.text(`รวม`, nameCol, yPos)
  doc.text(numberFormat(sumTrns), totalTrnsCol + 1, yPos, { align: "right" })
  doc.text(numberFormat(sumExp), totalExpCol + 1, yPos, { align: "right" })


  const total = sumTrns - sumExp
  const totalText = `สรุปรวม : (${total > 0 ? "ทอนคืน" : "จ่ายเพิ่ม"})${numberFormat(Math.abs(total))} บาท`
  const textWidth = doc.getTextWidth(totalText)
  const sumTextX = totalExpCol + 1.3
  doc.text(totalText, sumTextX, yPos)
  doc.rect(sumTextX - 0.15, yPos - 0.25, textWidth + 0.25, lineHeightDetail + 0.1, "S")

  //----------------------------------------- Other Expense -----------------------------------------
  doc.setFont("THSarabun", "bold")
  yPos += lineHeightDetail + lineHeightDetail / 2
  doc.text("ค่าใช้จ่ายอื่นๆ", startExpXpos, yPos)
  doc.setFont("THSarabun", "normal")
  yPos += lineHeightDetail
  if (joData.PCItemsOth.length > 0) {
    no = 0
    for (const exp of joData.PCItemsOth) {
      hasExpId.push(exp.ExpId)
      no++
      doc.text(`${no}.`, noCol, yPos)
      doc.text(`(${exp.IsCost ? "ต้นทุน" : "รายได้"})  ${exp.ExpNm}`, nameCol, yPos)
      // doc.text(numberFormat(exp.Amnt), amntCol + 1, yPos, { align: "right" })
      // doc.text(`${exp.Qty}`, qtyCol, yPos)
      doc.text(numberFormat(exp.Total), totalExpCol + 1, yPos, { align: "right" })
      yPos += lineHeightDetail - 0.04
      sumExp += +(exp.Total || 0)
    }
  } else {
    doc.text("(ไม่มี)", noCol, yPos)
  }

  yPos += lineHeightDetail * 2.5
  const signXPos = 6.3
  doc.line(signXPos - 1, yPos, signXPos + 1, yPos)
  yPos += lineHeightDetail
  doc.text("ผู้ตรวจสอบ", signXPos, yPos, { align: "center" })
  doc.text("Checklist", startX, yPos)
  yPos += lineHeightDetail
  const colExpWidth = pageSize[0] / 6
  let runCol = 0

  doc.setFont("THSarabun", "normal")
  const boxWidth = 0.1
  for (const expId of [2, 7, 6, 4, 3, 5, 107, 113, 107, 110, 86, 84]) {
    if (hasExpId.includes(expId)) continue
    const expNm = expId === 6 ? "OTหน้าประตู" : msData.expObj[expId]?.ExpNm || "-"
    doc.text(`${expNm}`, startX + boxWidth + 0.05 + (colExpWidth * runCol), yPos)
    doc.rect(startX + (colExpWidth * runCol), yPos - boxWidth, boxWidth, boxWidth, "S")
    runCol++
    if (runCol === 6) {
      yPos += lineHeightDetail
      runCol = 0
    }
  }
  // startJobOrder = numJobOrder
  // } while ((numJobOrder < joData.JobOrders.length) && !isPrintJobOrders)
  doc.output('dataurlnewwindow');
}